const SECURITY_MANAGEMENT_DEPARTMENT = "02412"

export const Variables = {
  SECURITY_MANAGEMENT_DEPARTMENT,
}
